import React from 'react'
import { Spinner } from '../../app/components/loader/EllipticalLoader'
import styled from 'styled-components'

const WelcomeVideoProfile = () => {
    return (
    <WelcomeScreen>
        <div>
            <h1 className="text-primary">Welcome!</h1>
            <p>Get ready, your profile interview will start shortly...</p>
        </div>
        <Spinner />
    </WelcomeScreen>
)
}

export default WelcomeVideoProfile

const WelcomeScreen = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height:100vh;
  background: transparent;
  color: ${({ theme }) => theme?.primary};
  text-align: center;
  padding: 2rem;
`;